module.exports = __webpack_public_path__ + "img/logo.ef30aa30.png";